import React from 'react'

import { FreightListType } from '@application/Types/ComponentTypes'

import { GlobalFreightGuideListItem } from './GlobalFreightGuideListItem'
import { useGetGlobalFreightCategoriesList } from './Hooks'

export const GlobalFreightGuideList = ({ title, language }: FreightListType): JSX.Element => {
    const categories = useGetGlobalFreightCategoriesList(language)

    return (
        <>
            {categories?.map((category) => (
                <GlobalFreightGuideListItem title={title} category={category} key={category.title} />
            ))}
        </>
    )
}
